import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import styled from "styled-components";

const ROWS = 2;

export default function RolesSkeleton() {
  const rows = Array.from(Array(ROWS).keys());

  return (
    <TableBody data-testid="role-list__skeleton">
      {rows.map(row => (
        <TableRow key={row} style={{ height: 60 }}>
          <TableCell>
            <Skeleton variant="text" animation="wave" height={20} width={80} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" animation="wave" height={20} width={100} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" animation="wave" height={20} width={80} />
          </TableCell>
          <TableCell align="right">
            <ActionsCell>
              <Skeleton
                variant="circle"
                animation="wave"
                height={26}
                width={26}
              />
            </ActionsCell>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}

const ActionsCell = styled.div`
  display: flex;
  justify-content: flex-end;
`;
